<template>
  <div id="side-panel" :class="smallTabletBreakpoint" class="flex-col gap-12" :style="{ minWidth: panelWidth }">
    <div :class="panelManagerWrapperStyles">
      <!-- Panel manager for desktop -->
      <PanelManager
        v-if="!isSmallTablet"
        :current-persistent-store="currentPersistentStore"
        :restore-original-result="restoreOriginalResult"
        :editor="editor"
        :toggle-panel="togglePanel"
        :stage="stage"
        :scale="initialScale"
        :getDataURL="props.getDataURL"
        :refreshAllHdLayers="props.refreshAllHdLayers"
        :stageHd="stageHd"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import "@/src/i18n";
import { Panel, useEditorStore } from "@/stores/editor_store";
import { PersistentStore } from "@/stores/persistent_store";
import { useMonitorSize } from "@/composables/monitor_size";
import PanelManager from "../panel_manager.vue";
import { computed, inject, StyleValue } from "vue";
import { Image } from "@/modules/internal_api/image";
import { Stage } from "konva/lib/Stage";
import { I18n as I18nType } from "i18n-js";
import { usePhotoEditor } from "@/composables/photo_editor";

const I18n: I18nType = inject("I18n");

interface SidePanelProps {
  currentPersistentStore: PersistentStore | null;
  isProcessing: boolean;
  backgroundActionButtonStyle: StyleValue;
  scale: number;
  stage: Stage;
  stageHd: Stage;
  editor: HTMLElement;
  initialScale: number;
  togglePanel: (id: Panel) => void;
  refreshTippy: () => void;
  getDataURL: (image: Image, stage: any, element: any) => string;
  refreshAllHdLayers: (image: Image) => Promise<void>;
}

const props = defineProps<SidePanelProps>();
const { isSmallTablet } = useMonitorSize();

const store = useEditorStore();

const { isNewEditorEnabled } = usePhotoEditor();

const restoreOriginalResult = (): void => {
  props.currentPersistentStore?.reset();
};

const isNewDesign = computed(() => {
  return isNewEditorEnabled.value;
});

const panelWidth = computed(() => {
  if (isNewDesign.value) {
    return store.openedPanel !== null ? "18rem" : "0";
  }
  return "24rem";
});

const panelManagerWrapperStyles = computed(() => {
  return {
    "z-5 absolute top-0": !isNewEditorEnabled.value,
    "panel-wrapper": isNewEditorEnabled.value,
  };
});

const smallTabletBreakpoint = computed(() => {
  return isSmallTablet.value ? "hidden" : "flex";
});
</script>
<style scoped>
.panel-wrapper {
  @media (min-width: 1024px) {
    max-width: 18rem;
  }
}
</style>
